import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon, EyeIcon, InfoIcon, LockIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { biomarkerDefs } from '../../data/biomarkers';
import { useBiomarkers } from '../../contexts/BiomarkersContext';
import { useLocale } from '../../contexts/LocaleContext';
import { formatIsoDate } from '../../utils/dates';
import { convertLabValue, formatLabValue } from '../../utils/units';

/** MOB/Profile/Health/Biomarkers — one row per biomarker definition. */
export function Biomarkers() {
  const {
    t,
    tl,
    locale
  } = useLocale();
  const navigate = useNavigate();
  const bio = useBiomarkers();
  return <div className="px-2 pb-2" data-id="element-2765" data-mp="3ufmp2vf148qp">
      <PageHeader title={t('bio.title')} subtitle={t('bio.subtitle')} showBack data-id="element-2766" data-mp="3uged9l6ar46y" />

      <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-2767" data-mp="3peynxgx36bir">
        {biomarkerDefs.map(def => {
        const latest = bio.recordsFor(def.id)[0];
        const unit = bio.unitFor(def.id);
        const shown = latest ? convertLabValue(latest.value, def.canonicalUnit, unit, def.factors) : null;
        const isPublic = bio.isPublic(def.id);
        return <li key={def.id} className="border-b border-sand-line last:border-b-0" data-id="element-2768" data-mp="3r6gwjlrfu11c">
              <button type="button" onClick={() => navigate(`/perfil/saude/biomarcadores/${def.id}`)} className="flex min-h-[72px] w-full items-center gap-2 py-2 text-left" data-id="element-2769" data-mp="3w5bslpef1m3e">
                <span className="min-w-0 flex-1" data-id="element-2770" data-mp="rny5bw6ref87">
                  <span className="block text-[13.5px] font-medium text-deep" data-id="element-2771" data-mp="dr2hgxlumj83">
                    {tl(def.name)}
                  </span>
                  {latest && shown !== null ? <span className="mt-[2px] block" data-id="element-2772" data-mp="2yfywyupxahso">
                      <span className="bee-num text-[17px] font-bold text-deep" data-id="element-2773" data-mp="2yil5awkn11by">
                        {formatLabValue(shown, def.decimals[unit] ?? 0, locale)}
                      </span>{' '}
                      <span className="text-[11.5px] text-muted" data-id="element-2774" data-mp="2jcp2u6pc15nn">{unit}</span>
                      <span className="block text-[11px] text-muted" data-id="element-2775" data-mp="2fd6jhfd5t2mx">
                        {t('bio.last')} · {formatIsoDate(latest.date, locale)}
                      </span>
                    </span> : <span className="mt-[2px] block text-[11.5px] text-muted" data-id="element-2776" data-mp="25jzgu29t00qj">
                      {t('bio.none')}
                    </span>}
                </span>
                <span className={`bee-overline flex shrink-0 items-center gap-1 rounded-pill border px-2 py-[3px] text-[8.5px] font-bold ${isPublic ? 'border-gold/55 text-gold-deep' : 'border-sand-line text-muted'}`} data-id="element-2777" data-mp="1vml164vpffza">
                  {isPublic ? <EyeIcon size={11} aria-hidden="true" data-id="element-2778" data-mp="3h190aosxmsru" /> : <LockIcon size={11} aria-hidden="true" data-id="element-2779" data-mp="3gz5yz8mbxd7t" />}
                  {isPublic ? t('bio.publicTag') : t('bio.private')}
                </span>
                <ChevronRightIcon size={16} className="shrink-0 text-muted" aria-hidden="true" data-id="element-2780" data-mp="3tijqewbe6ep7" />
              </button>
            </li>;
      })}
      </ul>

      <p className="mt-2 px-1 text-[11px] text-muted" data-id="element-2781" data-mp="74rx3gie1eur">{t('bio.future')}</p>
      <p className="mt-3 flex items-start gap-2 rounded-card border border-sand-line bg-sand-deep/50 p-2 text-[11.5px] leading-snug text-deep" data-id="element-2782" data-mp="35lvvq2ktp5vk">
        <InfoIcon size={14} className="mt-[1px] shrink-0 text-gold-deep" aria-hidden="true" data-id="element-2783" data-mp="3am1r9tu7rcix" />
        {t('bio.disclaimer')}
      </p>
    </div>;
}